import { theme } from '@chakra-ui/react'
export const tabTheme = theme.components.Tabs
